<template>
  <v-main style="background-color: #ebebeb">
    <v-container fluid style="height: 100% !important;">
      <router-view></router-view>
    </v-container>
  </v-main>
</template>

<script>
export default {};
</script>

<style>
</style>